import { createContext, useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { creatorsPageSelector, getCreatorsPage } from "./creatorspageSlice";
import { Toaster } from "sonner";
import { Outlet, useParams } from "react-router-dom";
import { FullLogo } from "../../assets/icons";

export const PageContext = createContext<any>(null);

const PublicCreatorsPage = () => {
  const { id: paramId } = useParams<{
    id: string;
    reference: string;
  }>();
  const dispatch = useAppDispatch();
  const { loading, data } = useAppSelector(creatorsPageSelector);

  useEffect(() => {
    if (paramId) {
      dispatch(getCreatorsPage(paramId));
    }
  }, [paramId, dispatch]);

  return (
    <>
      <section className="w-full h-full pb-10 bg-neutral-50">
        <header className="bg-white z-40 w-full py-2 fixed px-4 md:px-28 border-[1px] border-gray-300 flex items-center justify-between">
          <span>
            <FullLogo />
          </span>

          <div className="font-gt-w-medium text-sm flex items-center gap-4">
            <a
              href="https://aap.buymejollof.com/login"
              target="_blank"
              rel="noreferrer"
              className="text-[#121212]"
            >
              Log in
            </a>
            <a
              href="https://app.buymejollof.com/register"
              target="_blank"
              rel="noreferrer"
              className="flex items-center bg-[#f5f5f5] text-[#121212] h-8 w-fit px-4 rounded-full"
            >
              Join as a Creator
            </a>
          </div>
        </header>
        <section className="w-full md:w-[908px]  px-4 md:px-0 mx-auto pt-16 md:pt-20">
          <Toaster position="bottom-center" richColors />
          <PageContext.Provider value={{ data, loading }}>
            <Outlet />
          </PageContext.Provider>
        </section>
      </section>
    </>
  );
};

export default PublicCreatorsPage;
